import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { authSelectors } from 'app/auth/store/userSlice';
import { resolveBillingPermissions } from './resolveBillingPermissions';

export { resolveBillingPermissions } from './resolveBillingPermissions';

export const useBillingPermissions = () => {
  const permissions = useSelector(authSelectors.selectUserPermissions);

  return useMemo(() => resolveBillingPermissions(permissions), [permissions]);
};
